<fieldset class="fieldset" [ngClass]="{ 'is-open' : expanded }">
  <legend (click)="expanded = !expanded">
    <ng-container [ngSwitch]="expanded">
      <button mat-button *ngSwitchCase="true">
        <mat-icon svgIcon="chevron-down"></mat-icon>
        {{ legendTitle }}
      </button>

      <button mat-button *ngSwitchCase="false">
        <mat-icon svgIcon="chevron-right"></mat-icon>
        {{ legendTitle }}
      </button>
    </ng-container>
  </legend>

  <div class="fieldset-inner">
    <ng-content></ng-content>
  </div>
</fieldset>
